import { ICommand } from 'core-ts-types';
import { APGenericSlot } from '../../../../../global/builders/ap_generic_slot_builder';
import { RouterHelper } from '../../../../../global/helpers/router_helper';

class MarkAsUnmetDialog {
  private showDialog: boolean = true;
  private comment: string = '';
  private genericSlot: APGenericSlot;

  constructor(private deleteMarkAsMetEntryCommand: ICommand, private routerHelper: RouterHelper) {}

  openedChanged($event: any) {
    this.showDialog = $event.detail.value;
    if (!this.showDialog) {
      this.routerHelper.findStateAndGo('^.default');
    }
  }

  markAsUnmet() {
    this.deleteMarkAsMetEntryCommand(this.genericSlot).then(() => this.closeDialog());
  }

  closeDialog() {
    this.showDialog = false;
  }
}

angular.module('capability-ng-academic-planner').component('markAsUnmetDialog', {
  templateUrl:
    'capability-ng-academic-planner/src/global/components/mark_as_unmet/components/mark_as_unmet_dialog/mark_as_unmet_dialog.html',
  controller: MarkAsUnmetDialog,
  bindings: {
    genericSlot: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_unmet/components/mark_as_unmet_dialog/mark_as_unmet_dialog.ts